// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"3d95320e","787":"e15c2373"}[chunkId] + ".chunk.js";
};